module.exports = __webpack_public_path__ + "img/highGage.a6f98ea6.svg";